import { useRef } from "react";

/** Show table overlay on initial load or when `request` changes; skip it for background polls of the same request. */
const useTableFetchLoading = (isFetching: boolean, isLoading: boolean, request: unknown): boolean => {
    const requestKey = JSON.stringify(request ?? null);
    const settledRequestKeyRef = useRef<string | undefined>(undefined);

    if (!isFetching) {
        settledRequestKeyRef.current = requestKey;
    }

    return isLoading || (isFetching && settledRequestKeyRef.current !== requestKey);
};

export default useTableFetchLoading;
